import { ModalBcLineInfoComponent } from './../../modals/modal-bc-line-info/modal-bc-line-info.component';
import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, AfterContentChecked } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { NTHFlag } from 'src/app/shared/constants/flag';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { BcLineModel } from 'src/app/shared/models/societe-linked/bc/bc-line.model';
import { BcComponentsService } from '../../bc-components.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AmountComponentService } from 'src/app/core/amount.component.service';
import * as moment from 'moment';
import { BCLINEVALIDATORS } from 'src/app/shared/constants/bc-validators';

@Component({
  selector: 'app-fixed-bc-line-list-edit',
  templateUrl: './fixed-bc-line-list-edit.component.html',
  styleUrls: ['./fixed-bc-line-list-edit.component.scss']
})
export class FixedBcLineListEditComponent implements OnChanges, AfterContentChecked {
  @ViewChild('table', { static: true }) table;
  @Input() bcForm: UntypedFormGroup;

  @Output() amountHTsEmit = new EventEmitter<any[]>();
  @Output() amountTVAsEmit = new EventEmitter<any[]>();
  @Output() amountTTCsEmit = new EventEmitter<any[]>();

  bcLine: BcLineModel = new BcLineModel();
  showDelay = new UntypedFormControl(0);
  hideDelay = new UntypedFormControl(0);

  amountHTs: any;
  amountTVAs: any;
  amountTTCs: any;
  designation: string;
  bcLineRow: any;
  bcLineForm: UntypedFormArray;

  ValidationStatus: string[] = ['A Valider', 'Validation 1', 'Validation 2', 'Validation 3' , 'Validation 4'];
  displayedColumnsBC: string[] = ['libelle', 'qte', 'pu', 'mntHt', 'tva', 'ca1', 'naCode', 'cg',  'ca2', 'codeAe', 'complement', 'equipement',  'dLivraison', 'action'];
  matDataSourceBCLigne: MatTableDataSource<AbstractControl> = new MatTableDataSource<AbstractControl>();
  selection = new SelectionModel<BcLineModel>(true, []);
  public FlagEnum: NTHFlag;
  minDateLiv: string;
  constructor(
      private bcComponentsService: BcComponentsService,
      public dialog: MatDialog,
      private amountService: AmountComponentService,
      private changeDetectorRef: ChangeDetectorRef) {
    this.designation = '';
    this.bcLineRow = null;
    this.amountHTs = null;
    this.amountTVAs = null;
    this.amountTTCs = null;

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.bcForm) {
      this.bcForm.get('dBc').valueChanges.subscribe(x => {
        this.getMinDateLiv('dBc');
      });
      this.bcForm.get('dLivraison').valueChanges.subscribe(x => {
        this.getMinDateLiv('dLivraison');
      });
      this.bcLineForm = this.bcForm.get('bcLines') as UntypedFormArray;
      this.reload();
      this.getCalculatedAMounts();
    }
  }

  reload(): void {
    this.matDataSourceBCLigne = new MatTableDataSource<AbstractControl>(this.bcLineForm.controls);
  }

  ngAfterContentChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  openModal(i: number, row: UntypedFormGroup): void {
    this.bcLine = row.getRawValue();
    const form = this.bcComponentsService.getBcLineFormEdit(this.bcLine, BCLINEVALIDATORS.BROUILLON, i);
    const bcLineRef = this.bcComponentsService.getBcLineRef(i);
    const modalData = {
      referentiel: bcLineRef,
      i: i,
      bcLineForm: form,
      titre: 'Modification d\'une ligne BC'
    };
    const dialogRef = this.dialog.open(ModalBcLineInfoComponent, {
        disableClose: true,
        autoFocus: false,
        data: modalData
    });
    dialogRef.afterClosed().subscribe((res: UntypedFormGroup) => {
      if (res) {
        this.bcLineForm.at(i).patchValue(res.getRawValue());
      } else {
        this.bcLineForm.at(i).patchValue(this.bcLine);
      }
    });
  }

  addBcRow(): void {
    const myBcLineForm = this.bcComponentsService.createBcLine(this.bcForm);
    const index = this.bcLineForm.length;
    const bcLineRef = this.bcComponentsService.getBcLineRef(index);
    const modalData = {
      referentiel: bcLineRef,
      bcLineForm: myBcLineForm,
      i: index,
      titre: 'Ajout d\'une ligne BC',
      dBc: this.bcForm.get('dBc').value
    };
    const dialogRef = this.dialog.open(ModalBcLineInfoComponent, {
      disableClose: true,
      autoFocus: false,
      data: modalData,
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.bcLineForm.push(res);
        this.reload();
      } else {
        this.bcComponentsService.cancelCreatedLine();
      }
    });
  }

  deleteRow(row: UntypedFormGroup, i: number): void {
    this.bcComponentsService.removeBcLine(this.bcForm, i);
    this.reload();
  }

  duplicateRow(row: UntypedFormGroup, i: number): void {
    // TODO duplicate FormGroup + Map Line
    const myRow = this.bcComponentsService.duplicateBcLineRow(row);
    (this.bcForm.get('bcLines') as UntypedFormArray).push(myRow);
    this.reload();
  }

  calculateHorsTaxe(object: any): void {
    this.amountHTs = this.amountService.getHt(object);
    this.amountHTsEmit.emit(this.amountHTs);
  }

  calculateTva(object: any): void {
    this.amountTVAs = this.amountService.getTva(object);
    this.amountTVAsEmit.emit(this.amountTVAs);
  }

  calculateTtc(object: any): void {
    this.amountTTCs = this.amountService.getTtc(object);
    this.amountTTCsEmit.emit(this.amountTTCs);
  }

  getCalculatedAMounts(): void {
    this.bcLineForm.valueChanges.subscribe(e => {
      this.calculateHorsTaxe(e);
      this.calculateTva(e);
      this.calculateTtc(e);
    });
  }

  getMinDateLiv(date: string): void {
    if (this.bcForm.get(date)) {
      if (this.bcForm.get(date).value > Date.now()) {
        this.minDateLiv = moment(this.bcForm.get(date).value).format('YYYY-MM-DD');
      }
      for (const line of (this.bcForm.get('bcLines') as UntypedFormArray).controls) {
        if (this.bcForm.get(date).value > line.get('dLivraison').value) {
          line.get('dLivraison').setValue(this.bcForm.get(date).value);
        }
      }
    }
  }
}
